// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15OQ6","largestCol":"styles_largestCol__3kwdN","smallestCol":"styles_smallestCol__3zTKa"};